<template>
  <el-dialog class="lottery-history dialog-base" :class="{ 'mobile-edit': editing && $store.getters.isMobile }" :width="$store.getters.isMobile ? mobileWidth : '520px'" :visible.sync="visible" :modal="!editing">
    <div>
      <rich-text v-model="model.historyTitle" :editing="editing" />
      <div class="lottery-history__content mt-5">
        <div ref="listContainer" v-scroll-shadow class="list">
          <div v-for="(item, index) in list" :key="index" class="item flex items-center justify-between">
            <div class="flex items-center">
              <span class="mr-4 flex-shink-0">{{ index + 1 }}</span>
              <img class="w-[40px] h-[40px]" :src="item.gift_goods_logo" alt="">
              <i class="el-icon-close" />
              <span>{{ item.num }}</span>
            </div>
            <div class="time">
              <span class="ml-2">{{ item.lottery_time }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { Dialog } from 'element-ui'
import { formatZoneTime } from '~/utils'
import RichText from "~/components/richText/index.vue";
import scrollShadow from '../common/scrollShadow'

export default {
  components: {
    RichText,
    [Dialog.name]: Dialog
  },
  directives: {
    scrollShadow
  },
  props: {
    editing: {
      type: Boolean,
      default: false
    },
    model: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      list: [],
      visible: false
    }
  },
  computed: {
    mobileWidth() {
      return (this.editing && this.$store.getters.isMobile) ? '320px' : '90%'
    }
  },
  methods: {
    async init() {
      await this.getHistory()
      this.visible = true
      await this.$nextTick()
    },
    async getHistory() {
      if (this.editing) return
      const params = {
        activity_id: this.model.bizId,
        page_no: 1,
        page_size: 1000
      }
      const [err, res] = await this.$utils.to(this.$api.activity.historyList(params))
      if (!err && res.list) {
        this.list = res.list.map(item => {
          const newItem = {...item}
          newItem.lottery_time = formatZoneTime(newItem.lottery_time * 1000).text
          return newItem
        })
      }
    }
  }
}
</script>


<style lang="less">
@import '../common/dialogBase.less';
.lottery-history {
  .rich-text.focus-editor .ql-container.ql-snow {
    background-color: transparent;
  }
  .el-dialog__header {
    padding: 0 !important;
  }
  &.mobile-edit {
    .el-dialog {
      left: 10px;
    }
  }
  &__content {
    position: relative;
    &:before,
    &:after {
      content: '';
      position: absolute;
      left: 0;
      right: 0;
      height: 16px;
      pointer-events: none;
      opacity: 0;
      transition: opacity .2s ease;
      z-index: 10;
    }
    &:before {
      top: 0;
      background: linear-gradient(180deg, rgba(17,17,17,0.12) 0%, rgba(17,17,17,0) 100%);
    }
    &:after {
      bottom: 0;
      background: linear-gradient(0deg, rgba(17,17,17,0.12) 0%, rgba(17,17,17,0) 100%);
    }
    &.has-top-shadow:before { opacity: 1; }
    &.has-bottom-shadow:after { opacity: 1; }
    padding-top: 4px;
    .list {
      max-height: 400px;
      overflow-y: auto;
      display: flex;
      flex-direction: column;
      gap: 8px;
      padding-right: 4px;
      &::-webkit-scrollbar { width: 6px; height: 6px; }
      &::-webkit-scrollbar-thumb { background: rgba(0,0,0,0.15); border-radius: 6px; }
      .item {
        background-color: #fff;
        border: 1px solid #EFEFEF;
        border-radius: 12px;
        padding: 12px 14px;
        font-size: 12px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
        .flex { gap: 8px; }
        img { border-radius: 8px; }
        .el-icon-close { color: #8C8C8C; }
        .time { color: #666; font-size: 12px; }
        .flex span:first-child {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 24px;
          height: 24px;
          border-radius: 50%;
          background: #F0F0F5;
          font-weight: 600;
        }
      }
    }
  }
  &.mobile-edit {
    .lottery-history__content {
      .list {
        .item {
          border-radius: 10px;
          padding: 10px 12px;
        }
      }
    }
  }
}
</style>
